import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const subPopoverContent: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
};

export const subPopoverItem: SxStyle = {
  padding: (p) => p.spacing(1),
  cursor: 'pointer',

  '&:hover': {
    color: (p) => p.palette.primary[500],
    background: (p) => p.palette.primary[50],
  },
};
